import React, { Component } from "react";
import {
  PageHeader, Row, Col, Card, Statistic, Spin, Empty, message,
  Select, Space, Tooltip, Tabs,
} from "antd";
import {
  DollarOutlined, TrophyOutlined, RiseOutlined, ClockCircleOutlined,
  FileExcelOutlined, FilePdfOutlined,
} from "@ant-design/icons";
import {
  Form, FormItem, ButtonItem, SelectItem, RangePickerItem,
} from "../../../../Components/Items";
import { HeaderEmpresaCard } from "../../../../Components/PdfComponents/HeaderEmpresaCard";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

const fmt = (val) =>
  `$${(val ?? 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const CARD_STYLE = { borderRadius: 10, overflow: "hidden" };

const COLORES_PDF = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const PDF_STYLES = {
  header:               { fontSize: 9, bold: true },
  subheader:            { fontSize: 8, bold: true },
  tableExample:         { margin: [0, 5, 0, 5] },
  tableHeader:          { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  textoChico:           { fontSize: 8 },
  tituloTabla:          { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
  textoTabla:           { fontSize: 7 },
  totalChico:           { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "right" },
};

const buildBarras = (datos, getVal, getLabel, fmtFn = String) => {
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 190, H = 11, G = 5;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect", x: 0, y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H, color: COLORES_PDF[i % COLORES_PDF.length], r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  ${fmtFn(getVal(d))}`,
          style: "textoTabla", color: "#444", margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 10],
  };
};

class ReporteOportunidadesGanadas extends Component {
  formRef = React.createRef();

  state = {
    loading:     false,
    datosGanadas: [],
    kpis:        { totalValorGeneral: 0, totalLeadsGanados: 0, promedioValor: 0 },
    promedioDias: 0,
    embudos:     [],
    periodoStr:  "",
  };

  componentDidMount() {
    this.cargarEmbudos();
  }

  cargarEmbudos = async () => {
    const defaultValues = { periodo: [moment().startOf("year"), moment()] };
    try {
      const res = await axios.post(
        "embudos/selectEmbudosItem",
        { empresaId: this.props.empresaId, query: "" },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        this.setState({ embudos: res.data.embudos ?? [] }, () => {
          this.onFinish(defaultValues);
        });
      } else {
        this.onFinish(defaultValues);
      }
    } catch {
      this.onFinish(defaultValues);
    }
  };

  onFinish = (values) => {
    const { periodo, embudoId } = values;
    const periodoStr = periodo
      ? `${periodo[0].format("DD/MM/YYYY")} - ${periodo[1].format("DD/MM/YYYY")}`
      : "Histórico completo";
    this.setState({ periodoStr });
    this.cargarDatos({
      fechaInicio: periodo?.[0]?.toISOString() ?? null,
      fechaFin:    periodo?.[1]?.toISOString() ?? null,
      embudoId:    embudoId ?? null,
    });
  };

  cargarDatos = async ({ fechaInicio, fechaFin, embudoId } = {}) => {
    this.setState({ loading: true });
    try {
      const [resGanadas, resCiclo] = await Promise.all([
        axios.post(
          "reportesCRM/oportunidadesGanadasMensuales",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
        axios.post(
          "reportesCRM/cicloPromedioCierre",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
      ]);
      if (resGanadas.data.success === 2)
        this.setState({ datosGanadas: resGanadas.data.datos, kpis: resGanadas.data.kpis });
      if (resCiclo.data.success === 2)
        this.setState({ promedioDias: resCiclo.data.promedioDias });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  descargarExcel = () => {
    const { datosGanadas, kpis, promedioDias } = this.state;
    const filas = datosGanadas.map((d) => ({
      Mes:             d.mes,
      "Monto ($)":     d.totalValor,
      "Leads Ganados": d.cantidadLeads,
    }));
    filas.push({});
    filas.push({ Mes: "VALOR GANADO",    "Monto ($)": kpis.totalValorGeneral });
    filas.push({ Mes: "LEADS GANADOS",   "Monto ($)": kpis.totalLeadsGanados });
    filas.push({ Mes: "TICKET PROMEDIO", "Monto ($)": kpis.promedioValor });
    filas.push({ Mes: "CICLO PROMEDIO",  "Monto ($)": `${promedioDias} días` });
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Opors. Ganadas");
    XLSX.writeFile(wb, `Oportunidades_Ganadas_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.xlsx`);
  };

  descargarPdf = async () => {
    this.setState({ loading: true });
    try {
      const { datosGanadas, kpis, promedioDias, periodoStr } = this.state;

      const resEmpresa = await axios.post(
        "reportesCRM/datosEmpresaPdf",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      const empresa = resEmpresa.data.success === 2 ? resEmpresa.data.empresa : {};

      const grafica = datosGanadas.length
        ? buildBarras(datosGanadas, (d) => d.totalValor, (d) => d.mes, fmt)
        : null;

      const terceraColumna = {
        border: [false, false, false, false],
        table: {
          widths: ["100%"],
          body: [
            [{ text: "Oportunidades Ganadas CRM", style: "tableHeader", alignment: "center" }],
            [{ text: periodoStr, style: "textoChico", alignment: "center" }],
            [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
            [{ text: new Date().toLocaleDateString("es-MX"), style: "textoChico", alignment: "center" }],
          ],
        },
        layout: "noBorders",
      };

      const dd = {
        pageSize:    "LETTER",
        pageMargins: [20, 20, 20, 40],
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["15%", "55%", "30%"],
              body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
            },
          },
          { text: "Oportunidades Ganadas", style: "tableHeaderIzquierda", margin: [0, 6, 0, 8] },
          { text: "Resumen del Período", style: "subheader", margin: [0, 0, 0, 4] },
          {
            style: "tableExample",
            table: {
              widths: ["*", "*", "*", "*"],
              body: [
                [
                  { text: "Valor Ganado",    style: "tituloTabla" },
                  { text: "Leads Ganados",   style: "tituloTabla" },
                  { text: "Ticket Promedio", style: "tituloTabla" },
                  { text: "Ciclo de Cierre", style: "tituloTabla" },
                ],
                [
                  { text: fmt(kpis.totalValorGeneral), style: "totalChico", alignment: "center", fontSize: 11 },
                  { text: `${kpis.totalLeadsGanados}`, style: "totalChico", alignment: "center", fontSize: 11 },
                  { text: fmt(kpis.promedioValor),     style: "totalChico", alignment: "center", fontSize: 11 },
                  { text: `${promedioDias} días`,       style: "totalChico", alignment: "center", fontSize: 11 },
                ],
              ],
            },
            layout: { hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa" },
          },
          ...(grafica ? [
            { text: "Oportunidades por Mes", style: "subheader", margin: [0, 6, 0, 4] },
            grafica,
          ] : []),
          { text: "Detalle Mensual", style: "subheader", margin: [0, 6, 0, 4] },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "auto", "auto"],
              body: [
                [
                  { text: "Mes",           style: "tituloTabla" },
                  { text: "Monto",         style: "tituloTabla" },
                  { text: "Leads Ganados", style: "tituloTabla" },
                ],
                ...datosGanadas.map((d) => [
                  { text: d.mes,             style: "textoTabla" },
                  { text: fmt(d.totalValor), style: "textoTabla", alignment: "right" },
                  { text: d.cantidadLeads,   style: "textoTabla", alignment: "right" },
                ]),
              ],
            },
            layout: {
              fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          },
        ],
        images: { logo: empresa?.logo?.base64Completa ?? "" },
        styles: PDF_STYLES,
      };
      pdfMake.createPdf(dd).download(`Oportunidades_Ganadas_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.pdf`);
    } catch (e) {
      message.error("Hubo un error al generar el PDF.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, datosGanadas, kpis, promedioDias, embudos } = this.state;
    const { history } = this.props;
    const datosBar = datosGanadas.map((d) => ({ mes: d.mes, Monto: d.totalValor }));

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        initialValues={{ periodo: [moment().startOf("year"), moment()] }}
      >
        <PageHeader
          title={<span><DollarOutlined style={{ marginRight: 8, color: "#52c41a" }} />Oportunidades Ganadas</span>}
          subTitle="Oportunidades cerradas exitosamente por mes"
          onBack={() => history.push("/panel/crmReportes")}
          style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 15 }}
          extra={
            <Space wrap>
              {datosGanadas.length > 0 && (
                <Tooltip title="Descargar Excel">
                  <span>
                    <ButtonItem verde icon={<FileExcelOutlined />} onClick={this.descargarExcel} />
                  </span>
                </Tooltip>
              )}
              {datosGanadas.length > 0 && (
                <Tooltip title="Descargar PDF">
                  <span>
                    <ButtonItem rojo icon={<FilePdfOutlined />} onClick={this.descargarPdf} loading={loading} />
                  </span>
                </Tooltip>
              )}
              <ButtonItem azul htmlType="submit">Consultar</ButtonItem>
            </Space>
          }
        />

        {/* Cintillo de filtros */}
        <div style={{
          backgroundColor: "white", padding: 20, paddingTop: 5,
          borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", marginBottom: 10,
        }}>
          <Tabs
            defaultActiveKey="1"
            style={{ margin: 0 }}
            tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
          >
            <TabPane key="1" tab="Periodo">
              <FormItem name="periodo" noStyle>
                <RangePickerItem />
              </FormItem>
            </TabPane>
            <TabPane key="2" tab="Embudo">
              <FormItem name="embudoId" noStyle>
                <SelectItem
                  placeholder="Todos los embudos"
                  allowClear
                  style={{ width: "90%" }}
                >
                  {embudos.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombreEmbudo}</Option>
                  ))}
                </SelectItem>
              </FormItem>
            </TabPane>
          </Tabs>
        </div>

        <Spin spinning={loading}>
          <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            {[
              { titulo: "Valor Ganado",    valor: kpis.totalValorGeneral, prefix: <DollarOutlined />,      color: "#52c41a", format: true  },
              { titulo: "Leads Ganados",   valor: kpis.totalLeadsGanados, prefix: <TrophyOutlined />,      color: "#1890ff", format: false },
              { titulo: "Ticket Promedio", valor: kpis.promedioValor,     prefix: <RiseOutlined />,        color: "#722ed1", format: true  },
              { titulo: "Ciclo de Cierre", valor: promedioDias,           prefix: <ClockCircleOutlined />, color: "#fa8c16", format: false, suffix: "días" },
            ].map((k) => (
              <Col key={k.titulo} xs={12} sm={6} style={{ display: "flex" }}>
                <Card style={{ ...CARD_STYLE, flex: 1 }}>
                  <Statistic
                    title={k.titulo}
                    value={k.valor}
                    prefix={k.prefix}
                    suffix={k.suffix}
                    formatter={k.format ? (v) => fmt(v) : undefined}
                    valueStyle={{ color: k.color }}
                  />
                </Card>
              </Col>
            ))}
          </Row>

          <Card title="Oportunidades Ganadas" style={CARD_STYLE}>
            {datosBar.length === 0 && !loading ? (
              <Empty description="Sin oportunidades ganadas para el período seleccionado" />
            ) : (
              <div style={{ height: 340 }}>
                <ResponsiveBar
                  data={datosBar}
                  keys={["Monto"]}
                  indexBy="mes"
                  margin={{ top: 20, right: 20, bottom: 70, left: 90 }}
                  padding={0.3}
                  colors={["#52c41a"]}
                  borderRadius={4}
                  axisBottom={{ tickRotation: -35, tickSize: 5 }}
                  axisLeft={{ format: (v) => `$${(v / 1000).toFixed(0)}k` }}
                  tooltip={({ value, indexValue }) => (
                    <div style={{ background: "white", padding: "6px 12px", border: "1px solid #f0f0f0", borderRadius: 6 }}>
                      <strong>{indexValue}</strong>: {fmt(value)}
                    </div>
                  )}
                  labelSkipWidth={35}
                  label={(d) => fmt(d.value)}
                  theme={{ fontSize: 11 }}
                />
              </div>
            )}
          </Card>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ReporteOportunidadesGanadas));
